export const UPDATE_CLIENT_IMAGE = 'UPDATE_CLIENT_IMAGE';

export const updateClientImage = (clientId, image) => ({
  type: UPDATE_CLIENT_IMAGE,
  payload: { clientId, image }
});
